<div class="app-wrapper">
<mat-toolbar color="primary">
<h1>
  {{title}}
</h1>
</mat-toolbar>
<app-user-table></app-user-table>
</div>